
(() => {
  document.documentElement.classList.add('nh-js');
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const reveal = (root = document) => {
    const nodes = [...root.querySelectorAll('[data-nh-reveal]')];
    if (reduceMotion || !('IntersectionObserver' in window)) {
      nodes.forEach((node) => node.classList.add('is-visible'));
      return;
    }
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -5% 0px' });
    nodes.forEach((node) => observer.observe(node));
  };

  const bind = (root = document) => {
    reveal(root);
    root.querySelectorAll('[data-nh-card]').forEach((card) => {
      if (card.dataset.nhBound || reduceMotion) return;
      card.dataset.nhBound = 'true';
      card.addEventListener('pointermove', (event) => {
        const rect = card.getBoundingClientRect();
        card.style.setProperty('--mx', (((event.clientX - rect.left) / rect.width - .5) * 7) + 'px');
        card.style.setProperty('--my', (((event.clientY - rect.top) / rect.height - .5) * 7) + 'px');
      });
      card.addEventListener('pointerleave', () => {
        card.style.setProperty('--mx', '0px');
        card.style.setProperty('--my', '0px');
      });
    });
  };

  const stickyPurchase = () => {
    if (document.querySelector('.nhp-sticky-atc')) return;
    const form = document.querySelector('product-form form');
    const submit = form && form.querySelector('[name="add"]');
    if (!submit) return;
    const bar = document.createElement('aside');
    bar.className = 'nhp-sticky-atc';
    bar.setAttribute('aria-label', 'Schnell zum Warenkorb');
    const title = document.querySelector('.product__title h1')?.textContent?.trim() || 'Ausgewähltes Produkt';
    const price = document.querySelector('.price-item--sale, .price-item--regular')?.textContent?.trim() || '';
    bar.innerHTML = '<div><strong></strong><span></span></div><button type="button"></button>';
    bar.querySelector('strong').textContent = title;
    bar.querySelector('span').textContent = price;
    const button = bar.querySelector('button');
    const sync = () => {
      button.textContent = submit.textContent.trim();
      button.disabled = submit.disabled;
    };
    sync();
    new MutationObserver(sync).observe(submit, { attributes: true, childList: true, subtree: true });
    button.addEventListener('click', () => submit.click());
    document.body.appendChild(bar);
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(([entry]) => bar.classList.toggle('is-visible', !entry.isIntersecting), { threshold: 0 }).observe(submit);
    }
  };

  document.addEventListener('DOMContentLoaded', () => { bind(); stickyPurchase(); });
  document.addEventListener('shopify:section:load', (event) => { bind(event.target); stickyPurchase(); });
})();
